import { ReactNode } from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './ErrorFallback';

type ErrorBoundaryProps = {
    children: ReactNode;
};

const ErrorBoundary = ({ children }: ErrorBoundaryProps) => {
    return (
        <ReactErrorBoundary
            FallbackComponent={ErrorFallback}
            onError={(error, errorInfo) => {
                // Log additional error information
                console.error('Error Details:', errorInfo);
                if (errorInfo?.componentStack) {
                    console.error('Component Stack:', errorInfo.componentStack);
                }
                // You can also log to an error reporting service here
                // logErrorToService(error, errorInfo);
            }}
        >
            {children}
        </ReactErrorBoundary>
    );
};

export default ErrorBoundary;

